/**
 * Imports only the core styles
 *
 */

import './dnb-ui-core.scss'
